import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { CostCalculationMethods } from "../../../../enums/CostCalculationMethods";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { useTranslation } from "react-i18next";

const CompanyDetailMain = () => {
  const {t} = useTranslation();
  const costCalculationMethods = [
    { id: CostCalculationMethods.Average, name: "Average" },
    { id: CostCalculationMethods.FIFO, name: "FIFO" }
  ];

  const companyLegalFormLookup = [
    { id: 0, name: "Legal Entity" },
    { id: 1, name: "Private Person" }
  ];
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Name")} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <NFLookupInput title={t("LegalForm")} fieldName={"legalForm"} items={companyLegalFormLookup} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("TIN")} fieldName={"tin"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Prefix")} fieldName={"prefix"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("Description")} fieldName={"description"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title={t("RegistrationDate")} fieldName={"registrationDate"} />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={t("CostMethod")} fieldName={"costCalculationMethod"} items={costCalculationMethods} />
        </Col>
      </Row>
    </>
  );
};

export default CompanyDetailMain;
